// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","223":"commons","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"67520bdf8bb8be2917bf","223":"276294b786a16dc6a20b","293":"8cbd8ebb8e13ce14325c"}[chunkId] + ".js";
};